export default class TagsEnum {
    static TAGS_TRIGGER = '[data-trigger="wpet-toggle-tags"]'
    static TAGS_LIST = '[data-element="wpet-list-tags"]'
}
